
// src/helpers/pure-component.js

import React from 'react'
import shallowEqual from './shallow-equal'
import each from 'lodash/each'
import some from 'lodash/some'
import uniq from 'lodash/uniq'
import concat from 'lodash/concat'
import filter from 'lodash/filter'

export function PureComponent(keys = ['ui'], ignore = []) {
  return class ExPureComponent extends React.Component {
    shouldComponentUpdate(nextProps, nextState, nextContext) {
      keys = concat(keys)
      let otherProps = Object.assign({}, this.props)
      let nextOtherProps = Object.assign({}, nextProps)
      each(ignore, (key)=> {
        let paths = key.split('.')
        if (paths.length == 1) {
          delete otherProps[key]
          delete nextOtherProps[key]
        } else {
          keys.push(paths[0])
          otherProps[paths[0]] = Object.assign({}, otherProps[paths[0]])
          nextOtherProps[paths[0]] = Object.assign({}, nextOtherProps[paths[0]])
          delete otherProps[paths[0]][paths[1]]
          delete nextOtherProps[paths[0]][paths[1]]
        }
      })
      let changedProps = [] // for performance debug
      if (some(uniq(keys), (key)=> {
        let prop = otherProps[key]
        let nextProp = nextOtherProps[key]
        delete otherProps[key]
        delete nextOtherProps[key]
        if (!shallowEqual(prop, nextProp)) {
          //if ((!prop || !nextProp) && (prop || nextProp)) changedProps.push(`${key}.*`)
          //else changedProps = changedProps.concat(filter(Object.keys(nextProp), (_key)=> prop[_key] !== nextProp[_key]).map((_key)=> `${key}.${_key}`))
          return true
        }
        return false
      })) {
        //console.log(`shouldUpdate ${this.constructor.name} by props:${changedProps}`)
        return true
      }
      if (!shallowEqual(otherProps, nextOtherProps)) {
        //console.log(`shouldUpdate ${this.constructor.name} by props:${filter(Object.keys(nextOtherProps), (_key)=> typeof nextOtherProps[_key] != 'function' && otherProps[_key] !== nextOtherProps[_key]).map((_key)=> `${_key}`)}`)
        return true
      }
      if (!shallowEqual(this.state, nextState)) {
        //console.log(`shouldUpdate ${this.constructor.name} by state:${filter(Object.keys(nextState), (_key)=> this.state[_key] !== nextState[_key])}`)
        return true
      }
      if (!shallowEqual(this.context, nextContext)) {
        //console.log(`shouldUpdate ${this.constructor.name} by context`)
        return true
      }
      return false
    }
  }
}

export default PureComponent()



// WEBPACK FOOTER //
// ./src/helpers/pure-component.js